import { StandardLayout } from '@sequencehq/core-components'
import { OverviewHeader } from './OverviewHeader'
import { OverviewContent } from './content/OverviewContent'

export const Overview = () => {
  return (
    <StandardLayout
      backgroundColor="white"
      header={<OverviewHeader />}
      content={<OverviewContent />}
    />
  )
}
